import React, { FC, useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import Grid from 'components/UI/Grid';
import { useStores } from 'stores/hooks/hooks';
import { HALF_SCREEN_TABLE_TOP_HEIGHT } from 'core/constants';
import { Paper } from '@mui/material';
import { Column } from 'components/shared/DataTable/DataTable';
import { useTranslation } from 'react-i18next';
import {
  DataTableFilterMeta,
  DataTableRowClickEvent,
} from 'primereact/datatable';
import { FilterMatchMode } from 'primereact/api';
import DataTable from 'components/shared/DataTable';
import { WebPlot } from 'models/plot';
import { CreateFeatureForm } from 'stores/featuresStore';

const Container = styled(Paper)`
  display: flex;
  width: 100%;
  height: 100%;
`;

const DataTableContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

const FeaturesModels: FC = observer(() => {
  const { featuresStore } = useStores();
  const { selectedFeatures } = featuresStore;
  const { t } = useTranslation('feature');
  const tableFilters: DataTableFilterMeta = {
    id: { value: '', matchMode: FilterMatchMode.CONTAINS },
    name: { value: '', matchMode: FilterMatchMode.CONTAINS },
    latitude: { value: '', matchMode: FilterMatchMode.CONTAINS },
    longitude: { value: '', matchMode: FilterMatchMode.CONTAINS },
    'connectedSensors.length': {
      value: '',
      matchMode: FilterMatchMode.CONTAINS,
    },
  };

  const tableRows = useMemo(
    () => featuresStore.features,
    [featuresStore.features],
  );

  const onRowClick = useCallback(
    ({ data }: DataTableRowClickEvent) => {
      featuresStore.setSelectedFeatures(data as CreateFeatureForm);
    },
    [featuresStore],
  );

  return (
    <Container>
      <DataTableContainer>
        <DataTable
          id="FeatureTable"
          showGridlines
          resizableColumns
          value={JSON.parse(JSON.stringify(tableRows))}
          dataKey="id"
          emptyMessage={t('empty_message')}
          scrollable
          scrollHeight="100%"
          className="height-percent-100 width-percent-100"
          stripedRows
          filters={tableFilters}
          filterDisplay="row"
          selection={selectedFeatures}
          selectionMode="single"
          onRowClick={onRowClick}
        >
          <Column field="id" header={t('id')} sortable filter />
          <Column field="name" header={t('name')} sortable filter />
          <Column field="latitude" header={t('latitude')} sortable filter />
          <Column field="longitude" header={t('longitude')} sortable filter />
          <Column field="mlModelId.name" header={t('model')} sortable filter />
          <Column field="plotName" header={t('plot')} sortable filter />
        </DataTable>
      </DataTableContainer>
    </Container>
  );
});

export default FeaturesModels;
